
  // Check if the current page is the main collections page
  if (window.location.pathname === '/collections') {

    // Set meta title
    document.title = 'Shop Breathable Cotton Tees, Polos T Shirts & Shorts Online at Bombased';
    
    // Set new meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Shop our premium cotton t-shirts and organic cotton shorts from our collection. Comfortable, solid-colour shorts designed for movement and everyday ease. Shop online.');
  }
